import Footer from "../../components/Footer";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../App.css";

export const PrivacyPolicy = () => {
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return <div className="App">
        <nav className="navbar">
            <div className="nav-container">
                <div className="nav-logo">
                    <h2>AI Cards: Learn & Speak</h2>
                </div>

                <div className="nav-links">
                    <button onClick={() => navigate('/')} className="nav-link">Home</button>
                </div>
            </div>
        </nav>

        {/* Privacy Policy Content */}
        <section className="terms">
            <div className="container">
                <h2>Privacy Policy</h2>
                <div className="terms-content">
                    <div className="terms-section">
                        <p><strong>Last updated:</strong> March 2026</p>
                        <p>This Privacy Policy explains how the application (“the App”, “we”, “our”) collects, uses, and protects user information when you use our mobile application.</p>
                    </div>

                    <div className="terms-section">
                        <h3>Information We Collect</h3>
                        <p>We may collect limited information to improve the functionality of the App.</p>

                        <h4>Account Information</h4>
                        <p>If you create an account, we may collect:</p>
                        <ul>
                            <li>email address</li>
                            <li>authentication provider information (e.g., Google login)</li>
                        </ul>

                        <h4>Usage Data</h4>
                        <p>We may collect anonymous usage data such as:</p>
                        <ul>
                            <li>app interactions</li>
                            <li>feature usage</li>
                            <li>crash reports</li>
                            <li>performance diagnostics</li>
                        </ul>
                        <p>This information helps us improve the application experience.</p>

                        <h4>Conversations and Learning Data</h4>
                        <p>If the App includes AI conversations or learning interactions, the messages you send may be processed to provide responses and improve the service.</p>
                        <p>We do not sell user conversations or personal data.</p>
                    </div>

                    <div className="terms-section">
                        <h3>How We Use Information</h3>
                        <p>We use collected information to:</p>
                        <ul>
                            <li>provide and maintain the App</li>
                            <li>improve learning features</li>
                            <li>analyze usage and performance</li>
                            <li>fix bugs and technical issues</li>
                        </ul>
                    </div>

                    <div className="terms-section">
                        <h3>Third-Party Services</h3>
                        <p>The App may use third-party services that may collect information according to their own privacy policies. These may include services such as:</p>
                        <ul>
                            <li>analytics providers</li>
                            <li>authentication services</li>
                            <li>AI processing services</li>
                        </ul>
                        <p>We only integrate services necessary for the operation of the App.</p>
                    </div>

                    <div className="terms-section">
                        <h3>Data Security</h3>
                        <p>We take reasonable steps to protect user information from unauthorized access, alteration, or disclosure.</p>
                        <p>However, no internet service can be completely secure.</p>
                    </div>

                    <div className="terms-section">
                        <h3>Children's Privacy</h3>
                        <p>The App is not intended for children under the age of 13.</p>
                        <p>We do not knowingly collect personal information from children.</p>
                    </div>

                    <div className="terms-section">
                        <h3>Changes to This Privacy Policy</h3>
                        <p>We may update this Privacy Policy from time to time.</p>
                        <p>Any updates will be posted on this page.</p>
                    </div>

                    <div className="terms-section">
                        <h3>Contact</h3>
                        <p>If you have any questions about this Privacy Policy, you may contact us at:</p>
                        <p>aicardsfeedback@gmail.com</p>
                    </div>
                </div>
            </div>
        </section>

        <Footer />
    </div>

}
